import { AsyncPipe } from '@angular/common';
import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormModel, DynamicFormService, DynamicSelectModel } from '@ng-dynamic-forms/core';
import { Store } from '@ngrx/store';
import { CartActions, StateWithMultiCart } from '@spartacus/cart/base/core';
import { Cart } from '@spartacus/cart/base/root';
import { AuthService, LanguageService, TranslationService, UserIdService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { take } from 'rxjs/operators';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { CheckoutServiceExtends } from 'src/app/service/checkout/checkout.service';
import { ComponentService } from 'src/app/service/component.service';
import { MyaccountB2bunitService } from 'src/app/service/myaccount/myaccount-b2bunit.service';
import { FUTURE_ORDER, SnahCountryService } from 'src/app/service/snah/snah-countries.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { CheckoutFormService } from '../../../../core/checkout/facade/checkout-form.service';

@Component({
  selector: 'app-checkout-order-type',
  templateUrl: './checkout-order-type.component.html',
  styleUrls: ['./checkout-order-type.component.scss'],
  providers: [CheckoutFormService, AsyncPipe],
  standalone: false,
})
export class CheckoutOrderTypeComponent implements OnInit, OnDestroy, AfterContentChecked, AfterViewInit {
  formGroup: FormGroup;
  formModel: DynamicFormModel;
  formValue: any;
  formGroupOrderType: string = '';
  isActiveCountrySNAH: boolean;
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  placeOrderSubscription$: Subscription;
  orderTypeFormModelSubscription$: Subscription;
  orderTypeInfoFormGroupSubscription$: Subscription;
  totalSummaryPriceSubcription$: Subscription;
  snahFeaturesSubscription$: Subscription;
  activeCartSubscription$: Subscription;
  myB2bAccountSubscription$: Subscription;
  hasPlacedOrder = false;
  plannedOrder = false;
  totalSummaryprice: any;
  activeCart: any;
  errorText: string;
  selectedPlannedOrder: any;
  plannedOrderEnabledObs: Observable<boolean>;
  plannedOrderEnabled: boolean;
  orderTypeModel: DynamicSelectModel<string>;
  businessType: string = this.currentBusinesstype.getBusinessType();

  constructor(
    protected checkoutFormService: CheckoutFormService,
    private checkoutService: CheckoutServiceExtends,
    private authService: AuthService,
    private formService: DynamicFormService,
    private userIdService: UserIdService,
    private cdr: ChangeDetectorRef,
    private componentService: ComponentService,
    protected checkoutServiceExtends: CheckoutServiceExtends,
    private store: Store<StateWithMultiCart>,
    private cartService: CartExtendService,
    private languageService: LanguageService,
    private snahCountryService: SnahCountryService,
    protected translation: TranslationService,
    private myAccountB2BUnitService: MyaccountB2bunitService,
    private pipeAsync: AsyncPipe,
    private currentBusinesstype: CurrentBusinessType
  ) {
    // need to determine where default value coming from
    this.checkoutService
      .queryOrderType('SO')
      .pipe(take(1))
      .subscribe((cart: Cart) => {
        this.store.dispatch(
          new CartActions.LoadCart({
            userId: this.userCurrent,
            cartId: cart.code,
          })
        );
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
      });

    this.snahFeaturesSubscription$ = this.snahCountryService
      .getSnahFeatures(FUTURE_ORDER)
      .pipe(take(1))
      .subscribe((data) => (this.isActiveCountrySNAH = data));

    this.myB2bAccountSubscription$ = this.myAccountB2BUnitService
      .plannedOrderEnabled()
      .pipe(take(1))
      .subscribe((plannedOrderData: boolean) => {
        this.plannedOrderEnabled = plannedOrderData;
      });
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  ngOnInit() {
    this.placeOrderSubscription$ = this.checkoutServiceExtends.placeOrder$.subscribe((status) => {
      if (status) {
        if (this.formGroup.get('requestedDeliveryDate')) {
          this.formGroup.get('requestedDeliveryDate').disable({ onlySelf: true });
        }
        this.hasPlacedOrder = true;
      }
    });
    this.totalSummaryPriceSubcription$ = this.checkoutService.totalSummary$.subscribe((result) => {
      this.totalSummaryprice = result;
    });
    this.activeCartSubscription$ = this.cartService.activeCart$.subscribe((result) => {
      this.activeCart = result;
    });
  }

  updateFormGroup(form: any): void {
    this.formValue = form.value;
    this.formGroup = form;
    this.checkoutFormService.updateCheckoutForm(form.value);
  }

  updateFormModel(form: any): void {
    this.formModel = form;
    this.orderTypeModel = this.formService.findModelById<DynamicSelectModel<string>>('orderType', this.formModel);
    this.orderTypeModel.options = this.hidePlannedOrder(this.orderTypeModel);
    this.checkoutService.updateOrderType(this.orderTypeModel.value);
  }

  hidePlannedOrder(plannedOrder: any): any {
    let filteredOptions: any = [];
    if (this.isActiveCountrySNAH && this.activeCart && this.totalSummaryprice) {
      if (this.businessType == 'fish' && this.plannedOrderEnabled) {
        filteredOptions = plannedOrder.options.filter((option: any) => {
          if (option.label !== null) {
            if (this.orderTypeModel.value == 'PO' && this.totalSummaryprice < 5000) {
              this.checkoutServiceExtends.setCheckoutFormsError('CHECKOUT_ORDER_TYPE', true);
              this.formGroup.get('orderType').setErrors({ errValidation: true });
              const hasError = {
                errValidation: this.pipeAsync.transform(this.getTranslatedError(`cart.notQualifiedForPlannedOrder`)),
              };
              this.cdr.detectChanges();
              this.orderTypeModel.errorMessages = hasError;
            } else {
              this.checkoutServiceExtends.setCheckoutFormsError('CHECKOUT_ORDER_TYPE', false);
            }
            return option;
          }
        });
      } else {
        filteredOptions = plannedOrder.options.filter((option: any) => {
          if (option.label !== null) {
            if (this.plannedOrderEnabled === false) {
              return option.value === 'SO';
            } else {
              return option;
            }
          }
        });
      }
      this.cdr.detectChanges();
      return filteredOptions;
    }
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  getTranslatedError(id: string): Observable<string> {
    return this.translation.translate(`${id}`);
  }

  ngAfterViewInit() {
    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }
  ngAfterContentChecked() {
    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    if (this.placeOrderSubscription$) {
      this.placeOrderSubscription$.unsubscribe();
    }
    if (this.orderTypeFormModelSubscription$) {
      this.orderTypeFormModelSubscription$.unsubscribe();
    }
    if (this.orderTypeInfoFormGroupSubscription$) {
      this.orderTypeInfoFormGroupSubscription$.unsubscribe();
    }
    if (this.totalSummaryPriceSubcription$) {
      this.totalSummaryPriceSubcription$.unsubscribe();
    }
    if (this.snahFeaturesSubscription$) {
      this.snahFeaturesSubscription$.unsubscribe();
    }
    if (this.activeCartSubscription$) {
      this.activeCartSubscription$.unsubscribe();
    }
    if (this.myB2bAccountSubscription$) {
      this.myB2bAccountSubscription$.unsubscribe();
    }
  }
}
